// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2yL8g","container":"styles_container__1qeMe","title":"styles_title__2vlHZ","wrapper":"styles_wrapper__rRaeC","answer":"styles_answer__hJOFQ"};